import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import ForBuyers from "@/pages/ForBuyers";
import ForSuppliers from "@/pages/ForSuppliers";
import CaseStudies from "@/pages/CaseStudies";
import About from "@/pages/About";
import GetStarted from "@/pages/GetStarted";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin — standalone, no marketing chrome */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />

        {/* Marketing site */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/for-buyers" element={<ForBuyers />} />
          <Route path="/for-suppliers" element={<ForSuppliers />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/about" element={<About />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/enquire" element={<GetStarted />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="bottom-right" theme="light" richColors />
    </BrowserRouter>
  );
}

export default App;
